import template from './has-ramp.jade';
import itemsHasNo from '../../../enums/has-no';

export default angular
    .module('cian.addForm.hasRamp', ['cian.addForm.fieldTypeSwitcher'])
    .directive('cianAfAboutBuildingHasRamp', () => ({
        scope: {},
        bindToController: {
            ad: '=',
            form: '=',
        },
        controller() {
            this.items = itemsHasNo;
        },
        controllerAs: 'hasRamp',
        template,
    }))
    .name;
